module.exports = __webpack_public_path__ + "img/toxis-3.75e16595.jpg";